/**
 * Регистрирует иконку `parking-change-cross` — крест поверх кружка парковки,
 * знак «предположительно удалённой» парковки конкурента (DA-15432).
 *
 * Геометрия описана в SVG, но в карту уходит уже растром: map.loadImage в
 * mapbox-gl 2.x SVG не декодирует («SVGs are not supported»), поэтому SVG
 * рисуется в canvas через Image и отдаётся в addImage как ImageData. Растр
 * тройного разрешения (48 px на 16 px логического размера) — знак чистый на любом
 * зуме.
 *
 * Символьный слой с глифами '/' и '\' для этого не подошёл: штрихи тонкие и не
 * сходятся в центре, вместо креста получались две несовпадающие чёрточки.
 *
 * Остальные типы изменений различаются заливкой кружка и отдельного знака не
 * требуют.
 *
 * @param {object} map Инстанс mapboxgl.Map
 */
export const registerParkingChangeIcons = map => {
    const ID = 'parking-change-cross';
    if (map.hasImage(ID)) {
        return;
    }
    const PIXEL_RATIO = 3;
    const SIZE = 16;                       // логический размер иконки, px
    const BITMAP = SIZE * PIXEL_RATIO;     // фактический размер растра, px
    const CROSS_COLOR = '#ef4444';
    // Крест на всю иконку: белая подложка для контраста поверх любой обводки
    // оператора, сверху красный штрих. Координаты в системе viewBox 48x48.
    const svg = [
        `<svg xmlns="http://www.w3.org/2000/svg" width="${BITMAP}" height="${BITMAP}" viewBox="0 0 48 48">`,
        '<g stroke-linecap="round" fill="none">',
        '<path d="M8 8 L40 40 M40 8 L8 40" stroke="rgba(255,255,255,0.9)" stroke-width="13"/>',
        `<path d="M8 8 L40 40 M40 8 L8 40" stroke="${CROSS_COLOR}" stroke-width="7"/>`,
        '</g>',
        '</svg>',
    ].join('');
    const img = new Image(BITMAP, BITMAP);
    img.onload = () => {
        if (map.hasImage(ID)) {
            return;
        }
        const canvas = document.createElement('canvas');
        canvas.width = BITMAP;
        canvas.height = BITMAP;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, BITMAP, BITMAP);
        ctx.drawImage(img, 0, 0, BITMAP, BITMAP);
        map.addImage(ID, ctx.getImageData(0, 0, BITMAP, BITMAP), {
            sdf: false,
            pixelRatio: PIXEL_RATIO,
        });
    };
    img.onerror = () => {
        console.error(`[parking-change-icons] не удалось растеризовать SVG для ${ID}`);
    };
    img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
};
